import React from 'react'
import moment from 'moment'
import _ from "lodash"

const CombinedSetStatisticsTable = (props) => {
    const { data = [], loading } = props

    return (
        <div className="PackingItemTable">
            <table className="table table-borderless table-striped">
                <thead className='thead-light PackingItemHeader'>
                    <tr>
                        <th className='barcode'>Barcode item</th>
                        <th className='sku'>SKU</th>
                        <th className='basket-number'>Số giỏ</th>
                        <th className='part'>Part</th>
                        <th className='time'>Thời gian</th>
                        <th className='user'>User</th>
                        <th className='type'>Loại thao tác</th>
                    </tr>
                </thead>
                <tbody className="PackingItemRow">
                    {
                        data.map((item, i) => {
                            return (
                                <tr key={item._id}>
                                    <td>{`#${_.get(item, 'item', '-')}`}</td>
                                    <td>{_.get(item, 'meta.type', '-')}</td>
                                    <td>{_.get(item, 'meta.basket_number', '-')}</td>
                                    <td>{_.get(item, 'meta.set', '-')}</td>
                                    <td>{moment(_.get(item, 'created_at', '-')).format("HH:mm DD/MM/YYYY")}</td>
                                    <td>{_.get(item, 'user', '-')}</td>
                                    <td>{_.get(item, 'action', '-') === "add_set_item_to_basket" ? "Thêm vào giỏ" : _.get(item, 'action', '-') === "remove_set_item_from_basket" ? "Xóa giỏ" : '-'}</td>
                                </tr>
                            )
                        })
                    }
                    {
                        !loading && (!data || data.length === 0) &&
                        <tr>
                            <td colSpan={8}>
                                No result
                            </td>
                        </tr>
                    }
                </tbody>
            </table>
        </div>
    )
}

export default CombinedSetStatisticsTable